import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import * as firebase from 'firebase';

const styles = {
  centeredContent: {
    textAlign: 'center',
  },
}

class UpdatePasswordForm extends Component {
  state = {
    valid: false,
    currentPassword: '',
    newPassword1: '',
    newPassword2: '',
    passErrorMsg: '',
  }

  static propTypes = {
    onRequestClose: PropTypes.func,
  };

  /**
   * Whenever the passwords update, validate the form
   * @param {Props} nextProps
   * @param {State} nextState
   */
  componentWillUpdate(nextProps, nextState) {
    const { currentPassword, newPassword1, newPassword2 } = this.state;
    const { currentPassword: nCurrentPassword, newPassword1: nNewPassword1, newPassword2: nNewPassword2 } = nextState;
    if (currentPassword !== nCurrentPassword || newPassword1 !== nNewPassword1 || newPassword2 !== nNewPassword2) {
      this.validateForm(nextState);
    }
  }

  /**
   * Validate the form based on the passed state
   */
  validateForm = (state) => {
    const { newPassword1, newPassword2 } = state;
    let valid = true;
    let errorMessage = '';

    if (newPassword1 === '') {
      // errorMessage = 'Password can\'t be empty';
      valid = false;
    }

    if (newPassword1 !== newPassword2) {
      if (newPassword2 !== '') {
        errorMessage = 'Passwords don\'t match';
      }
      valid = false;
    }

    this.setState({
      valid: valid,
      passErrorMsg: errorMessage,
    });
  }

  /**
   * Notify parent component that the dialog can be closed
   */
  handleClose = () => {
    this.props.onRequestClose();
  }

  /**
   * Handle form submission
   */
  requestPasswordChange = () => {
    const user = firebase.auth().currentUser;
    const { currentPassword, newPassword1 } = this.state;

    // First re-authenticate the user using the given credentials
    const credential = firebase.auth.EmailAuthProvider.credential(
      user.email,
      currentPassword,
    );
    user.reauthenticateWithCredential(credential)
      .then(() => {
        // User re-authenticated, proceed with password change
        user.updatePassword(newPassword1)
          .then(() => {
            // Update successful.
            alert('Your password was updated.');
            this.handleClose();
          })
          .catch(error => {
            alert(error.message);
          });
      })
      .catch(error => {
        // An error happened, show a message saying that the password was incorrect
        if (error && error.code === 'auth/wrong-password') {
          alert('The password you entered is incorrect.');
          // TODO: Show reset password button here
        } else if (error && error.message) {
          alert(error.message);
        } else {
          alert('Please try again.');
        }
      });
  }

  /**
   * Update state.currentPassword
   */
  handleCurrentPassChange = (event, val) => {
    this.setState({
      currentPassword: val,
    });
  }

  /**
   * Update state.newPassword1
   */
  handleNewPass1Change = (event, val) => {
    this.setState({
      newPassword1: val,
    });
  }

  /**
   * Update state.newPassword2
   */
  handleNewPass2Change = (event, val) => {
    this.setState({
      newPassword2: val,
    });
  }

  render() {
    const { passErrorMsg } = this.state;

    const actions = [
      <FlatButton
        label="Cancel"
        onTouchTap={this.handleClose}
      />,
      // somehow make this component catch enters
      <FlatButton
        label="Ok"
        disabled={!this.state.valid}
        primary={true}
        onTouchTap={this.requestPasswordChange}
      />,
    ];

    return (
      <Dialog
        title="Update password"
        actions={actions}
        modal={false}
        open={true}
        onRequestClose={this.handleClose}
      >
        <div style={styles.centeredContent}>
          <TextField type="password" floatingLabelText="Current password" onChange={this.handleCurrentPassChange} />
          <br/>

          <TextField type="password" floatingLabelText="New password" onChange={this.handleNewPass1Change} />
          <br/>
          <TextField type="password" floatingLabelText="Confirm new password" errorText={passErrorMsg} onChange={this.handleNewPass2Change} />
        </div>
      </Dialog>
    )
  }
}

export default UpdatePasswordForm;



// WEBPACK FOOTER //
// ./src/components/UpdatePasswordDialog/index.jsx